
module.config(function($stateProvider) {

    $stateProvider.state('student.followup', {
        url: '/followup',
        templateUrl: 'students/followup/page',
        controller: 'FollowupPageController',
        resolve: {

            verifications: function(ModelService, student) {
                return ModelService.getModelRelation(student, 'verifications');
            },

            followups: function(ModelService, student) {
                return ModelService.getModelRelation(student, 'followup');
            }
        }
    });

});